<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Product
            <v-icon right>add_circle</v-icon>
          </v-btn>
          <v-btn color="primary" @click="openDialog=true">Import Product</v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field name="name" label="Product Name" type="text" v-model="queryParams.name"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field name="code" label="Product Code" type="text" v-model="queryParams.code"></v-text-field>
            </v-flex>
             <v-flex sm3>
              <v-text-field name="code" label="Product Color" type="text" v-model="queryParams.color"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="brandName"
                label="Brand Name"
                type="text"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="categoryName"
                label="Category Name"
                type="text"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productGroupName"
                label="Product Group Name"
                type="text"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
             <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-btn
              color="primary"
              :loading="buttonLoading"
              @click="printProductList('printProductList')"
            >PRINT ALL</v-btn>
            <v-btn
                :loading="buttonLoading"
                color="success"
                @click="exportAllProduct()"
              >EXPORT ALL</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr >
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.code +"/" + props.item.brand.name +"/"+props.item.category.name }}</td>
                 <td>{{ props.item.color }}</td>
                <td v-if="props.item.productGroup">{{ props.item.productGroup.name}}</td>
                <td v-else></td>
                <td>{{ props.item.reorderQty }}</td>
                <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                  <v-icon v-else medium color="red">cancel</v-icon>
                </td>
                <td>
                  <v-btn flat icon color="blue lighten-2" @click.stop="onEdit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.productUnits"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.factor +"/"+ subprops.item.unitName}}</td>
                      <td class="text-xs">{{ subprops.item.barcode }}</td>
                      <td class="text-xs">{{ subprops.item.unitCost }}</td>
                      <td class="text-xs">{{ subprops.item.sellingPrice }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <productExcel :isOpen="openDialog" v-on:change="dialogClose()"></productExcel>
    <div id="printProductList" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Product List</p>
      </div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Name</th>
              <th style="text-align:left">Code/Brand/Category</th>
              <th style="text-align:left">Product Color</th>
              <th style="text-align:left">Product Group</th>
              <th style="text-align:left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allproductList" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.code +"/" + item.brand.name +"/"+item.category.name }}</td>
              <td>{{ item.color }}</td>
              <td v-if="item.productGroup">{{ item.productGroup.name}}</td>
              <td v-else></td>
              <td>{{ item.status}}</td>
            </tr>
          </tbody>
        </table>
        <div style="height:10px"></div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { productService } from "../../services/product-service";
import productExcel from "../../components/product/ProductExcel";
import { commonService } from "../../services/common-service";

export default {
  name: "ProductList",

  components: { productExcel },
  data: () => ({
    showListLoading: false,
    buttonLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Product",
        disabled: true
      }
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code/Brand/Category/", value: "code" },
      { text: "Product Color", value: "color" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Reorder Level", value: "reorderQty" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false }
    ],

    subHeaders: [
      { text: "Factor/Unit", sortable: false },
      { text: "Barcode", sortable: false },
      { text: "Unit Price", sortable: false },
      { text: "Selling Price", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0
    },
    productList: [],
    allproductList: [],
    openDialog: false,
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    queryParams: {
      name: "",
      code: "",
      color: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.color) {
      this.queryParams.color = this.$route.query.color;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.brandName) {
      this.queryParams.brandName = this.$route.query.brandName;
    }
    if (this.$route.query.categoryName) {
      this.queryParams.categoryName = this.$route.query.categoryName;
    }
    if (this.$route.query.productGroupName) {
      this.queryParams.productGroupName = this.$route.query.productGroupName;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "products", query: this.queryParams });
      this.getProductList();
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printProductList(divName) {
      this.buttonLoading = true;
      productService
        .getAllProductList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allproductList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    exportAllProduct() {
      this.buttonLoading = true;
      productService
        .getProductExcelExport(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        });
      this.buttonLoading = false;
    },
    onRegister() {
      this.$router.push("/product/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getProductList();
    },
    onEdit(product) {
      // go to details page
      this.$router.push("/product/" + product.id);
    }
  }
};
</script>